export default __webpack_public_path__ + "static/media/emptycart.f4deb64e.png";